module.exports = "/_next/static/files/50a0d0a5e545bead53a775e7dfad7236.jpg";